import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BadgePercent, ArrowUpRight } from 'lucide-react';
import useSpecialOfferCampaign from './useSpecialOfferCampaign';
import './SpecialOfferFloatingLink.css';
export default function SpecialOfferFloatingLink() {
  const { pathname } = useLocation();
  const { settings } = useSpecialOfferCampaign();
  if (pathname === '/special-offer' || settings?.showFloatingLink === false) return null;
  return <Link className="sym-sale-floating-link" to="/special-offer" aria-label="See SYM machine special offers">
    <BadgePercent size={20}/><span>MACHINES<br/><b>ON SALE</b></span><ArrowUpRight size={17}/>
  </Link>;
}
